/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

const BREAKPOINTS = {
  MOBILE: "mobile",
  TABLET: "tablet",
  DESKTOP: "desktop",
  WIDESCREEN: "widescreen",
  FULLHD: "fullhd"
};

const mqMobile = window.matchMedia("screen and (max-width: 768px)");
const mqTablet = window.matchMedia(
  "screen and (min-width: 769px) and (max-width: 1023px)"
);
const mqDesktop = window.matchMedia(
  "screen and (min-width: 1024px) and (max-width: 1215px)"
);
const mqWidescreen = window.matchMedia(
  "screen and (min-width: 1216px) and (max-width: 1407px)"
);
const mqFullhd = window.matchMedia("screen and (min-width: 1408px)");

function getActiveQueryName() {
  if (mqMobile.matches) {
    return BREAKPOINTS.MOBILE;
  }
  if (mqTablet.matches) {
    return BREAKPOINTS.TABLET;
  }
  if (mqDesktop.matches) {
    return BREAKPOINTS.DESKTOP;
  }
  if (mqWidescreen.matches) {
    return BREAKPOINTS.WIDESCREEN;
  }
  if (mqFullhd.matches) {
    return BREAKPOINTS.FULLHD;
  }
  throw new Error("No breakpoint matches!");
}

export {
  mqMobile,
  mqFullhd,
  mqWidescreen,
  mqDesktop,
  mqTablet,
  getActiveQueryName,
  BREAKPOINTS
};
